import { render, staticRenderFns } from "./RemoveEPMattersComponent.vue?vue&type=template&id=5294d376&scoped=true"
import script from "./RemoveEPMattersComponent.vue?vue&type=script&lang=js"
export * from "./RemoveEPMattersComponent.vue?vue&type=script&lang=js"
import style0 from "./RemoveEPMattersComponent.vue?vue&type=style&index=0&id=5294d376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5294d376",
  null
  
)

export default component.exports